export default __webpack_public_path__ + "static/media/FirstImage.d8adba6d.png";